import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class KozDokumentView extends BaseEntity{

    constructor(){
        super();
    }
    PodVrstaDokumentaStavka: string;
    BrojDokumenta: string;
    Datum: NgbDate;
    Komitent:  string;
    Napomena: string;
    Tarifa: string;

    Deserialize(input: any){
        this.ID = input.ID;
        this.PodVrstaDokumentaStavka = input.PodVrstaDokumentaStavka;
        this.BrojDokumenta = input.BrojDokumenta;
        this.Datum = input.Datum;
        this.Komitent = input.Komitent;
        this.Napomena = input.Napomena;
        this.Tarifa = input.Tarifa;
        return this;
    }

    Serialize(input: KozDokumentView){
        return input;
    }
}